export default __webpack_public_path__ + "static/unlock_cloud-db5536b93fa7bdeb56da33ffc5a1f48c.webp";